module.exports = __webpack_public_path__ + "img/img7.13ca40a0.png";